var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4375C7.05844 2.4375 3.1875 4.66125 3.1875 7.5V16.5C3.1875 19.3388 7.05844 21.5625 12 21.5625C16.9416 21.5625 20.8125 19.3388 20.8125 16.5V7.5C20.8125 4.66125 16.9416 2.4375 12 2.4375ZM12 3.5625C16.1672 3.5625 19.6875 5.36531 19.6875 7.5C19.6875 9.63469 16.1672 11.4375 12 11.4375C7.83281 11.4375 4.3125 9.63469 4.3125 7.5C4.3125 5.36531 7.83281 3.5625 12 3.5625ZM19.6875 16.5C19.6875 18.6347 16.1672 20.4375 12 20.4375C7.83281 20.4375 4.3125 18.6347 4.3125 16.5V14.5116C5.8125 16.0462 8.65969 17.0625 12 17.0625C15.3403 17.0625 18.1875 16.0462 19.6875 14.5116V16.5ZM19.6875 12C19.6875 14.1347 16.1672 15.9375 12 15.9375C7.83281 15.9375 4.3125 14.1347 4.3125 12V10.0116C5.8125 11.5463 8.65969 12.5625 12 12.5625C15.3403 12.5625 18.1875 11.5463 19.6875 10.0116V12Z",
    fill: "#9E874A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.ffb4c5615d50aa6f80bd950e48e7ef26.svg";
export { ForwardRef as ReactComponent };